import React, { Component } from 'react'
import classes from './Burger-Menu.css'

class BurgerMenu extends Component {
    render() {
        return (
            <div className={classes.BurgerMenu}>
                <input id={classes.menu__toggle} type="checkbox" />
                <label class={classes.menu__btn} for={classes.menu__toggle}>
                    <span></span>
                </label>
                <ul class={classes.menu__box}>
                    <li><a class={classes.menu__item} href="/">Главная</a></li>
                    <li><a class={classes.menu__item} href="">АЭКС</a></li>
                    <li><a class={classes.menu__item} href="/collector/construction">солнечный коллектор в акЭС</a></li>
                    <li><a class={classes.menu__item} href="">система приёма передачи энергии в акЭС</a></li>
                    <li><a class={classes.menu__item} href="/feadback">обратная связь</a></li>
                </ul>
            </div>
        )
    }
}
export default BurgerMenu


// WEBPACK FOOTER //
// ./src/hoc/Menu/Burger-menu.js